import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from 'libs/authentication/src/lib/components/login/login.component';
import { AuthErrorComponent } from 'libs/shared/src/lib/components/auth-error/auth-error.component';
import { Error404Component } from 'libs/shared/src/lib/components/error404/error404.component';
import { FlowErrorComponent } from 'libs/shared/src/lib/components/flow-error/flow-error.component';
import { GenericErrorComponent } from 'libs/shared/src/lib/components/generic-error/generic-error.component';
import { LoginErrorComponent } from 'libs/shared/src/lib/components/login-error/login-error.component';
import { SessionExpiredComponent } from 'libs/shared/src/lib/components/session-expired/session-expired.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'auth', loadChildren: () => import(`@vfa-cp/authentication`).then(m => m.AuthenticationModule) },
  { path: 'orders', loadChildren: () => import(`@vfa-cp/orders`).then(m => m.OrdersModule) }, //AuthGuard OnInit del padre
  { path: 'details', loadChildren: () => import(`@vfa-cp/details`).then(m => m.DetailsModule) }, //AuthGuard OnInit del padre
  { path: 'dashboard', loadChildren: () => import(`@vfa-cp/dashboard`).then(m => m.DashboardModule) }, //AuthGuard OnInit del padre
  { path: 'renewal', loadChildren: () => import(`@vfa-cp/renewal`).then(m => m.RenewalModule) }, //AuthGuard OnInit del padre
  { path: 'automotive/renewal', loadChildren: () => import(`@vfa-cp/automotive-renewal`).then(m => m.AutomotiveRenewalModule) }, //AuthGuard OnInit del padre
  { path: 'legacy-migration', loadChildren: () => import(`@vfa-cp/legacy-migration`).then(m => m.LegacyMigrationModule) }, //AuthGuard OnInit del padre
  { path: 'core/error/error', component: GenericErrorComponent },
  { path: 'core/error/404', component: Error404Component },
  { path: 'core/error/flow-error', component: FlowErrorComponent },
  { path: 'core/error/auth-error', component: AuthErrorComponent },
  { path: 'core/error/session-expired', component: SessionExpiredComponent },
  { path: 'core/error/login-error', component: LoginErrorComponent },
  { path: '**', redirectTo: 'core/error/404' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
